import BigLogo from "@publicPortal/components/bigLogo/BigLogo";
import ResultBoard from "@publicPortal/components/resultBoard/ResultBoard";
import { UserService } from "@publicPortal/services/UserService";
import React, { memo, useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
import { planningApplicationDetailsState } from "../planningApplication/PlanningApplication";
import { RecordDetailsTabNames } from "@publicPortal/utils/enums";
import { IConsulteeProcess } from "../verifyConsultee/VerifyConsultee";
import { IUser } from "@shared/mirage/core/contracts/IUser";
import { PublicPortalRoutingService } from "@publicPortal/services/PublicPortalRoutingService";
import { userState } from "@mirage/store/UserStore";
import { useStableNavigate } from "@mirage/hooks/useStableNavigate";
import DateFormatter from "@shared/mirage/helpers/DateFormatter";
interface LoginConsulteeProps {
    paId: number;
    consulteeEmail: string;
    consulteePassword: string;
}

const userService = new UserService();
const pp = new PublicPortalRoutingService();

const LoginConsultee: React.FC<LoginConsulteeProps> = memo(({ paId, consulteeEmail, consulteePassword }) => {
    const user: Partial<IUser> = UserService.getLoggedInUser();
    const navigate = useStableNavigate();
    const setUser = useSetRecoilState(userState);
    const initialState = {
        message: "",
        error: "",
    } as IConsulteeProcess;
    const [consulteeLogin, setConsulteeLogin] = useState<IConsulteeProcess>(initialState);
    const [isLoading, setIsLoading] = useState(true);
    const setApplicationTabState = useSetRecoilState(planningApplicationDetailsState);

    useEffect(() => {
        const loginConsultee = async () => {
            if (user?.id || !consulteeEmail || !consulteePassword) {
                setIsLoading(false);
                return;
            }
            const loginResult = await userService.login({ email: consulteeEmail, password: consulteePassword, timeZone: DateFormatter.currentTimezone });
            if (loginResult.errorMsg) {
                updateConsulteeLogin(loginResult.errorMsg, loginResult.errorMsg);
            }
            setUser({ ...loginResult, first_name: loginResult.userName, last_name: loginResult.userLastName, id: Number(loginResult.userId) });
            setIsLoading(false);
        };
        loginConsultee();
    }, [consulteeEmail, consulteePassword, setUser, user?.id]);

    useEffect(() => {
        const redirectUserToPlanningApplication = () => {
            if (isLoading) {
                return;
            }
            if (!paId) {
                updateConsulteeLogin("Could not redirect to planning record", "No paId found");
                return;
            }
            if (!consulteeLogin.error) {
                setApplicationTabState(() => {
                    return {
                        [paId]: RecordDetailsTabNames.Consultations,
                    };
                });
                navigate(pp.PlanningApplicationRecordRoute(paId));
            }
        };

        redirectUserToPlanningApplication();
    }, [consulteeLogin.error, isLoading, navigate, paId, setApplicationTabState]);

    return (
        <>
            <BigLogo />
            <ResultBoard
                headerText={"Login Consultee"}
                loading={isLoading}
                success={!consulteeLogin.error}
                message={consulteeLogin.message}
                buttonLabel="Go home"
                buttonNavTo={pp.Root}
            />
        </>
    );

    function updateConsulteeLogin(message: string, error?: string) {
        setConsulteeLogin(() => {
            return {
                message: message,
                error: error,
            };
        });
    }
});

export default LoginConsultee;
